import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyB0MUovKuJquEEO67VtIBhGJHYnIWs5EeI",
  authDomain: "mobicom-8e616.firebaseapp.com",
  projectId: "mobicom-8e616",
  storageBucket: "mobicom-8e616.firebasestorage.app",
  messagingSenderId: "675342263665",
  appId: "1:675342263665:web:1a070d41b095b8e1a302d0",
  measurementId: "G-QTDE1C2K69",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app); // Get messaging instance

// export const onMessageListener = () =>
//     new Promise((resolve) => {
//         onMessage(messaging, (payload) => {
//             resolve(payload)
//         })
//     })
